import styled from 'styled-components';

export const Logo = styled.img`
  height: 24px;
  cursor: pointer;
  @media only screen and (max-width: 1728px) {
    height: 16px;
  }
`;
